import {
  createFileRoute,
  Link,
  Outlet,
  redirect,
} from "@tanstack/react-router";

export const Route = createFileRoute("/admin")({
  beforeLoad: ({ context }) => {
    const isAdmin =
      context.auth.authenticated &&
      context.auth.roles.includes("echorai-admin");
    if (!isAdmin) {
      throw redirect({ to: "/" });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-8 py-8">
      <div className="mb-6 flex flex-col gap-4 border-b pb-4 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-2xl font-bold tracking-tight">Echorai Admin</h1>
        <nav className="flex gap-1">
          <AdminNavLink to="/admin" exact>
            Ärenden
          </AdminNavLink>
          <AdminNavLink to="/admin/sites">Webbplatser</AdminNavLink>
        </nav>
      </div>
      <Outlet />
    </div>
  );
}

function AdminNavLink({
  to,
  exact = false,
  children,
}: {
  to: string;
  exact?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Link
      to={to}
      activeOptions={{ exact }}
      className="rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
      activeProps={{
        className: "bg-muted text-foreground",
      }}
    >
      {children}
    </Link>
  );
}
